module.exports = __webpack_public_path__ + "img/spotify.d154494c.png";